"use client";
import { useEffect, useState } from "react";
import { useRouter } from "next/navigation";
import { useAuthStore } from "@/store/authStore";
import Link from "next/link";
import { FaGear, FaChevronLeft } from "react-icons/fa6";
import api from "@/lib/api";

export default function AccountPage() {
  const router = useRouter();
  const { isAuthenticated, user, logout, checkAuth } = useAuthStore();
  const [playlists, setPlaylists] = useState([]);

  useEffect(() => {
    if (!isAuthenticated) {
      router.push("/auth");
    } else {
      checkAuth();
    }
  }, [isAuthenticated, router]);

  async function fetchPlaylists() {
    try {
      const res = await api("/api/v1/top-playlists", { method: "GET" });
      if (res.status === "ok") {
        setPlaylists(res.data);
      }
    } catch (e) {
      console.log(e);
    }
  }

  useEffect(() => {
    fetchPlaylists();
  }, []);

  if (!user) return null;

  const thisYear = new Date().getFullYear();

  return (
    <div className="p-5 md:max-w-xl md:mx-auto text-white pb-10">
      {/* Profile Card */}
      <div className="relative rounded-2xl bg-gradient-to-br from-[#0f2a3d] to-[#123246] p-5 overflow-hidden">
        <div className="absolute -top-10 -left-10 w-32 h-32 bg-c3/20 rounded-full blur-2xl" />
        <div className="flex items-center gap-4 relative z-10">
          <div className="relative">
            <img
              src={process.env.NEXT_PUBLIC_ASSETS_URL + user.image}
              alt={user.first_name}
              className="w-20 h-20 rounded-full object-cover ring-2 ring-c3 ring-offset-2 ring-offset-[#0f2a3d]"
            />
          </div>
          <div className="flex-1">
            <div className="text-lg font-semibold">
              {user.first_name} {user.last_name}
            </div>
            <div className="text-sm text-gray-300 mt-1 flex items-center gap-2 flex-wrap">
              {user.age && (
                <span>{thisYear - parseInt(user.age.split("-")[0])} ساله</span>
              )}
              {user.age && user.city && <span className="w-1 h-1 rounded-full bg-gray-500" />}
              {user.city && <span>از {user.city}</span>}
            </div>
          </div>
        </div>

        <Link
          href="/account/setting"
          className="mt-5 w-full text-white bg-c3 hover:bg-c3/90 transition-colors rounded-xl text-sm px-5 py-3 flex items-center justify-center gap-2 font-medium shadow-lg shadow-c3/20"
        >
          <FaGear />
          <span>تنظیمات </span>
        </Link>
      </div>

      {/* Popular Playlists */}
      {playlists.length > 0 && (
        <div className="mt-8">
          <div className="flex items-center justify-center mb-6">
            <h2 className="text-base font-semibold text-center">
              مجموعه‌های پرطرفدار این هفته
            </h2>
          </div>

          <div className="grid grid-cols-3 gap-x-4 gap-y-6">
            {playlists.map((pl) => (
              <Link
                key={pl.id}
                href={`/playlist/${pl.slug}`}
                className="group flex min-w-0 flex-col items-center gap-2"
              >
                <div
                  className="
                        w-full md:max-w-28 rounded-full p-0.5
                        bg-gradient-to-tr from-yellow-400 via-pink-500 to-purple-600
                        group-hover:bg-none group-hover:bg-c3
                        group-focus:bg-none group-focus:bg-c3
                        transition-all duration-200 shadow-md
                      "
                >
                  <div className="relative w-full aspect-square rounded-full overflow-hidden bg-black">
                    <img
                      src={
                        process.env.NEXT_PUBLIC_ASSETS_URL +
                        (pl.hero_image || pl.image)
                      }
                      alt={pl.name}
                      className="absolute inset-0 block w-full h-full object-cover"
                    />
                  </div>
                </div>

                <span
                  className="
              w-full text-xs text-center text-gray-200
              line-clamp-1
              group-hover:text-c3 transition-colors
            "
                >
                  {pl.name}
                </span>
              </Link>
            ))}
          </div>
        </div>
      )}

    </div>
  );
}
